// extracted by mini-css-extract-plugin
export default {"root":"PaDxf9rZTaQkzNiWMaCs"};